import SingleCategoryPage from './SingleCategory-Container';
export default SingleCategoryPage;
